import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative border-t border-white/[0.08] py-14">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="mb-4 flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-button">
                <span className="text-base font-bold text-white">A</span>
              </div>
              <span className="text-xl font-bold text-white">Alenis</span>
            </div>
            <p className="max-w-sm leading-relaxed text-brand-muted">{t('landing.footer.description')}</p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">
              {t('landing.footer.company')}
            </h4>
            <ul className="space-y-3 text-sm text-brand-muted">
              <li>
                <Link to="/about" className="transition-colors hover:text-white">
                  {t('landing.footer.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="transition-colors hover:text-white">
                  {t('landing.footer.contact')}
                </Link>
              </li>
              <li>
                <Link to="/careers" className="transition-colors hover:text-white">
                  {t('landing.footer.careers')}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="transition-colors hover:text-white">
                  {t('landing.footer.blog')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">
              {t('landing.footer.legal')}
            </h4>
            <ul className="space-y-3 text-sm text-brand-muted">
              <li>
                <Link to="/rodo" className="transition-colors hover:text-white">
                  {t('landing.footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link to="/regulamin" className="transition-colors hover:text-white">
                  {t('landing.footer.termsOfService')}
                </Link>
              </li>
              <li>
                <Link to="/login" className="transition-colors hover:text-white">
                  {t('landing.footer.signIn')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/[0.08] pt-8 sm:flex-row">
          <p className="text-sm text-brand-muted">
            © {new Date().getFullYear()} Alenis. {t('landing.footer.rights')}
          </p>
          <a
            href="mailto:alenis.services@gmail.com"
            className="text-sm font-medium text-brand-secondary transition-colors hover:text-white"
          >
            alenis.services@gmail.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
